module.exports = __webpack_public_path__ + "/images/cover-acompanamos-embarazo.ecbc593.webp";